import { differenceInMinutes } from "date-fns";
export const sortDate = (a, b) => {
    if (!a || !b)
        return 0;
    if (a < b)
        return -1;
    if (a > b)
        return 1;
    return 0;
};
export const isMoreThanOneHourUntil = (date, now) => {
    return differenceInMinutes(date, now) > 60;
};
export const getRandomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};
